import { Typography } from "components/atoms";
import { useGetGuaranteeOnboardingFormQuery } from "services/onboardingFormsAPI";
import "./index.scss";

export const OnboardingFormTitleSection = () => {
  const { isLoading, isError, data } = useGetGuaranteeOnboardingFormQuery();

  return (
    <div className="onboarding-form-title-section-wrapper">
      <Typography
        label="Tell us more about yourself"
        variant="h7Book"
        styles="title-custom-style"
      />
      <Typography
        label={`You must complete this form before you gain access to the ${!isLoading && !isError ? data?.TargetTestDate.Test : ""} course.`}
        variant="h7Book"
        styles="sub-text-custom-style"
      />
    </div>
  );
};
